module.exports = __webpack_public_path__ + "img/emoji-photos@3x.9055b68.png";